import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

/**
 * StudioBrief — a short statement of who Depmont is, sitting between the hero
 * and the work on the homepage. Deliberately brief: the full story lives at /about.
 */
export default function StudioBrief() {
    return (
        <section className="py-24 md:py-36 border-t border-[#E6E2D6]">
            <div className="mx-auto max-w-[1800px] px-6 md:px-12 lg:px-20">
                <div className="grid grid-cols-12 gap-6 md:gap-10">
                    <div className="col-span-12 md:col-span-3">
                        <p className="eyebrow text-[#1B1B1B]/70">
                            § The Studio
                        </p>
                    </div>

                    <div className="col-span-12 md:col-span-9">
                        <motion.p
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-15%" }}
                            transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
                            className="font-serif-editorial text-3xl md:text-5xl lg:text-6xl leading-[1.12] tracking-[-0.02em] text-[#1B1B1B] max-w-4xl"
                        >
                            Depmont is an independent creative company. We build
                            identities, editorial systems and digital
                            experiences for people who intend to be around in{" "}
                            <em className="italic text-[#A8844F]">
                                ten years.
                            </em>
                        </motion.p>

                        <motion.div
                            initial={{ opacity: 0 }}
                            whileInView={{ opacity: 1 }}
                            viewport={{ once: true, margin: "-15%" }}
                            transition={{ duration: 1, delay: 0.2 }}
                            className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 max-w-4xl"
                        >
                            <p className="font-sans-tight text-base md:text-lg leading-[1.7] text-[#1B1B1B]/85 font-light">
                                We stay small on purpose. A limited number of
                                engagements each year means we work closely,
                                think properly, and put our name on everything
                                that leaves the studio.
                            </p>
                            <p className="font-sans-tight text-base md:text-lg leading-[1.7] text-[#1B1B1B]/85 font-light">
                                We do not measure ourselves in awards or years.
                                We measure the work by whether it still reads
                                as correct a decade from now.
                            </p>
                        </motion.div>

                        <div className="mt-12 flex flex-wrap items-center gap-x-10 gap-y-4">
                            <Link
                                to="/about"
                                className="eyebrow link-underline text-[#1B1B1B]"
                            >
                                More about the studio →
                            </Link>
                            <Link
                                to="/approach"
                                className="eyebrow link-underline text-[#1B1B1B]/70"
                            >
                                How we work →
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
